import { render, staticRenderFns } from "./fidelior-alerts.vue?vue&type=template&id=861a8c20&"
import script from "./fidelior-alerts.vue?vue&type=script&lang=js&"
export * from "./fidelior-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports